"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoInputChooser = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useAudioVideoDevice = require("@studio/chime/hooks/useAudioVideoDevice");
var _DeviceTypes = require("@studio/constants/DeviceTypes");
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StyledSelect = _styledComponents["default"].select(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: #6e7582;\n  border: 1px solid #dfe3ec;\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin: 10px 0px;\n  width: 100%;\n  @media screen and (max-width: 768px) {\n    width: 100%;\n  }\n"])));
var VideoInputChooser = exports.VideoInputChooser = function VideoInputChooser(_ref) {
  var meetingSession = _ref.meetingSession,
    onVideoInputChanged = _ref.onVideoInputChanged,
    selectedVideoInputId = _ref.selectedVideoInputId,
    id = _ref.id;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    devices = _useState2[0],
    setDevices = _useState2[1];
  (0, _useAudioVideoDevice.useAudioVideoDevice)({
    meetingSession: meetingSession,
    setDevices: setDevices,
    onDeviceChanged: onVideoInputChanged,
    selectedDeviceId: selectedVideoInputId,
    deviceType: _DeviceTypes.VIDEO_INPUT
  });
  return /*#__PURE__*/_react["default"].createElement(StyledSelect, {
    id: id,
    onChange: function onChange(event) {
      return onVideoInputChanged(event.target.value);
    }
  }, devices.map(function (_ref2) {
    var deviceId = _ref2.deviceId,
      label = _ref2.label;
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: deviceId,
      value: deviceId,
      selected: deviceId === selectedVideoInputId
    }, label);
  }));
};
VideoInputChooser.propTypes = {
  meetingSession: _propTypes.object.isRequired,
  onVideoInputChanged: _propTypes.func.isRequired,
  selectedVideoInputId: _propTypes.string,
  id: _propTypes.string
};